
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4148_15258)"}},[_c('path',{attrs:{"d":"M17.516 3.438h-15A1.562 1.562 0 00.953 5v10a1.563 1.563 0 001.563 1.563h15A1.563 1.563 0 0019.078 15V5a1.563 1.563 0 00-1.562-1.563zm-.313 1.874v1.563H2.828V5.312h14.375zM2.828 14.688V8.75h14.375v5.938H2.828zm13.438-1.874a.937.937 0 01-.938.937h-2.5a.938.938 0 010-1.875h2.5a.937.937 0 01.938.938zm-5.313 0a.937.937 0 01-.937.937h-.938a.938.938 0 010-1.875h.938a.937.937 0 01.937.938z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4148_15258"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.016)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    